module.exports = __webpack_public_path__ + "static/media/grin-stars.99253b97.svg";